const API_URL = '/v3/company-agreements';
import axios from 'axios';
import qs from 'qs';

export default {
  namespaced: true,
  state() {
    return {
      loading: false,
      loading_delete: false,
      companyAgreementList: [],
      companyAgreementPublicList: []
    };
  },

  mutations: {
    SET_LOADING(state, val) {
      state.loading = val;
    },
    SET_LOADING_DELETE(state, val) {
      state.loading_delete = val;
    },
    SET_LIST(state, val) {
      state.companyAgreementList = val;
    },
    SET_PUBLIC_LIST(state, val) {
      state.companyAgreementPublicList = val;
    }
  },

  actions: {
    addCompanyAgreement({ commit, dispatch }, data) {
      data.names.forEach((field, ind) => {
        if (field.name.length === 0) {
          data.names.splice(ind, 1);
        }
      });

      commit('SET_LOADING', true);

      return axios
        .post(API_URL, data)
        .then(() => {
          dispatch('fetchCompanyAgreementsList');
        })
        .catch(err => {
          return Promise.reject(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    deleteCompanyAgreement({ commit, dispatch }, id) {
      commit('SET_LOADING_DELETE', true);

      return axios
        .delete(`${API_URL}/${id}`)
        .then(() => {
          dispatch('fetchCompanyAgreementsList');
        })
        .catch(err => {
          return Promise.reject(err);
        })
        .finally(() => {
          commit('SET_LOADING_DELETE', false);
        });
    },

    fetchCompanyAgreementsList({ commit }) {
      commit('SET_LOADING', true);

      let params = {
        with: ['names', 'names.language', 'file'],
        limit: 999
      };

      return axios
        .get(API_URL, {
          params,
          paramsSerializer: params => qs.stringify(params)
        })
        .then(res => {
          commit('SET_LIST', res.data._embedded.agreements);
        })
        .catch(err => {
          return Promise.reject(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    fetchPublicCompanyAgreementsList({ commit }, token) {
      commit('SET_LOADING', true);

      let params = {
        with: ['names', 'names.language', 'file'],
        limit: 999
      };

      return axios
        .get(`/v3/public/vacancy/${token}/company-agreements`, {
          params,
          paramsSerializer: params => qs.stringify(params)
        })
        .then(res => {
          commit('SET_PUBLIC_LIST', res.data._embedded.agreements);
        })
        .catch(err => {
          return Promise.reject(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    }
  }
};
